import { render, staticRenderFns } from "./CommentReactAddBtn.vue?vue&type=template&id=46cd8a53&scoped=true&"
import script from "./CommentReactAddBtn.vue?vue&type=script&lang=js&"
export * from "./CommentReactAddBtn.vue?vue&type=script&lang=js&"
import style0 from "./CommentReactAddBtn.vue?vue&type=style&index=0&id=46cd8a53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cd8a53",
  null
  
)

export default component.exports